"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: function root(_ref) {
      var color = _ref.color;
      return {
        color: color,
        display: 'grid',
        gridAutoColumns: '1fr',
        justifyItems: 'center',
        alignContent: 'center',
        rowGap: '1.2rem',
        textAlign: 'center',
        height: '100%',
        '*': {
          color: 'inherit'
        }
      };
    },
    background: function background(_ref2) {
      var color = _ref2.color;
      return {
        backgroundColor: color,
        filter: 'brightness(.5)',
        opacity: 0.25,
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0
      };
    },
    main: {
      fontWeight: 'bold',
      fontSize: '1.5rem'
    }
  };
});
var _default = useStyles;
exports["default"] = _default;